//@flow
import React from 'react'
import swissData from '../../data/schweiz.json'
import swissDataFR from '../../data/schweizFR.json'
import internationalData from '../../data/international.json'
import internationalDataFR from '../../data/internationalFR.json'
import './styles.scss'

function numberWithApostroph(x) {
  let num = x.toString()
  if(num.length > 4) {
    num = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  }
  return num;
}

function Column({ data, lang, isMobile }) {
  return (
    <div className={'column'}>
      <h3>{data.city}</h3>
      <img src={require('../../images/'+data.image+'.jpeg')} alt={data.image}/>
      <div className='pop'>
        {numberWithApostroph(data.pop)} <span className='unit'>{isMobile ? 'Pers.' : 'Personen'} / km<sup>2</sup></span>
      </div>
    </div>
  )
}

export class International extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }
  
  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    this.chData = this.props.tenant.lang === 'fr' ? swissDataFR : swissData
    this.intData = this.props.tenant.lang === 'fr' ? internationalDataFR : internationalData

    return <div className='international'>
      <h2>{this.props.tenant.lang === 'fr' ? this.props.titleFR : this.props.titleDE}</h2>
      <div className="wrapper" onClick={this.setRandomCities}>
        <div className='two-column'>
            
            <Column data={this.chData[0]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />
            <Column data={this.intData[0]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />

            <Column data={this.chData[1]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />
            <Column data={this.intData[1]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />

            <Column data={this.chData[2]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />
            <Column data={this.intData[16]} lang={this.props.tenant.lang} isMobile={this.state.isMobile} />
            
        </div>
        <div className='source'>
            {this.props.tenant.lang === 'fr' ? 'Source: Calcul Tamedia' : 'Quelle: Eigene Berechnungen'}, <a href='https://twitter.com/undertheraedar/status/1622625736992468992'>Alasdair Rae</a>
        </div>
      </div>
    </div>
  }
}



             